module.exports = __webpack_public_path__ + "img/bianji.b3f564b8.svg";